define("auth/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "auth/config/environment", "auth/resolver"], function (_exports, _engine, _emberLoadInitializers, _environment, _resolver) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/engine",0,"ember-load-initializers",0,"auth/config/environment",0,"auth/resolver"eaimeta@70e063a35619d71f
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const {
    modulePrefix
  } = _environment.default;
  class Eng extends _engine.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "modulePrefix", modulePrefix);
      _defineProperty(this, "Resolver", _resolver.default);
      _defineProperty(this, "dependencies", {
        services: ['alerts', 'auth', 'cache', 'dialogManager', 'errors', 'instagram', 'intl', 'laterConfig', 'linkedin', 'locale', 'onboarding', 'plans', 'pinterest', 'router', 'seamlessCheckoutManager', 'session', 'segment', 'segmentEvents', 'shared/popup-manager', 'social/facebook-auth', 'social/instagram-auth', 'social/instagram-business', 'store', 'subscriptions', 'tiktok', 'twitter', 'userConfig'],
        externalRoutes: ['account.overview', 'plans', 'plans.plan', 'cluster.schedule', 'cluster.collect.contribute', 'subscription']
      });
    }
  }
  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = _exports.default = Eng;
});